export default __webpack_public_path__ + "static/media/logo.9f1ba95f.png";